export default __webpack_public_path__ + "194c8eef9719528d53d4f88d0bc73b9f.png";